import $ from "jquery";

if (document.querySelector(".sliderblogmobile")) {
    const blogSliders = document.querySelectorAll(".sliderblogmobile");
    blogSliders.forEach(slider => {
        $(slider).slick({
            slidesToShow: 1,
            arrows:false,
            dots: true,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

}